var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"s2",attrs:{"fluid":""}},[_c('v-container',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('landingpage.verbDescription'))+" "+_vm._s(_vm.$t('landingpage.learningEase'))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }